var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "monitor-detail-modal" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "监控商品详情",
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            "destroy-on-close": "",
            width: "1200px",
            "custom-class": "monitor-detail-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.handleClose,
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "detail-content",
            },
            [
              _vm.detailInfo.productId
                ? _c("div", { staticClass: "product-card" }, [
                    _c(
                      "div",
                      { staticClass: "product-info" },
                      [
                        _c("el-image", {
                          staticClass: "product-image",
                          attrs: {
                            src: _vm.detailInfo.productImage,
                            "preview-src-list": [_vm.detailInfo.productImage],
                            fit: "cover",
                          },
                        }),
                        _c("div", { staticClass: "product-desc" }, [
                          _c("div", { staticClass: "product-name" }, [
                            _vm._v(" ("),
                            _c("span", { staticClass: "text-primary" }, [
                              _vm._v(_vm._s(_vm.detailInfo.productId)),
                            ]),
                            _vm._v(
                              ") " + _vm._s(_vm.detailInfo.productName) + " "
                            ),
                          ]),
                          _c("div", { staticClass: "sku-name" }, [
                            _vm._v(
                              "SKU：" + _vm._s(_vm.detailInfo.skuName || "-")
                            ),
                          ]),
                          _c("div", { staticClass: "info-row" }, [
                            _c("span", [
                              _vm._v(
                                "商户名称：" +
                                  _vm._s(_vm.detailInfo.merchantName || "-")
                              ),
                            ]),
                            _c("span", { staticClass: "ml40" }, [
                              _vm._v(
                                "商品品牌：" +
                                  _vm._s(_vm.detailInfo.brandName || "-")
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "info-row" }, [
                            _c("span", [
                              _vm._v(
                                "商品成本价：" +
                                  _vm._s(
                                    _vm.detailInfo.costPrice
                                      ? _vm.detailInfo.costPrice + "元"
                                      : "-"
                                  )
                              ),
                            ]),
                            _c("span", { staticClass: "ml40" }, [
                              _vm._v(
                                "商城售价：" +
                                  _vm._s(
                                    _vm.detailInfo.salePrice
                                      ? _vm.detailInfo.salePrice + "元"
                                      : "-"
                                  )
                              ),
                            ]),
                          ]),
                        ]),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "section-title mt20" }, [
                _vm._v("价格监测记录"),
              ]),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.tableLoading,
                      expression: "tableLoading",
                    },
                  ],
                  attrs: {
                    data: _vm.recordList,
                    size: "small",
                    stripe: "",
                    "max-height": "300",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "序号",
                      type: "index",
                      width: "60",
                      index: function (i) {
                        return (
                          (_vm.tableFrom.page - 1) * _vm.tableFrom.limit + i + 1
                        )
                      },
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "monitorTime",
                      label: "监控时间",
                      "min-width": "150",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "txPrice",
                      label: "添星售价",
                      "min-width": "100",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                scope.row.txPrice != null
                                  ? scope.row.txPrice
                                  : "-"
                              )
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "taobaoPrice",
                      label: "淘宝价",
                      "min-width": "100",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                scope.row.taobaoPrice != null
                                  ? scope.row.taobaoPrice
                                  : "-"
                              )
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "与淘宝变动幅度", "min-width": "130" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "span",
                              { class: _vm.getDiffClass(scope.row.taobaoDiff) },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.formatDiff(
                                        scope.row.taobaoDiff,
                                        scope.row.taobaoDiffRate
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "jdPrice",
                      label: "京东价",
                      "min-width": "100",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                scope.row.jdPrice != null
                                  ? scope.row.jdPrice
                                  : "-"
                              )
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "与京东变动幅度", "min-width": "130" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "span",
                              { class: _vm.getDiffClass(scope.row.jdDiff) },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.formatDiff(
                                        scope.row.jdDiff,
                                        scope.row.jdDiffRate
                                      )
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "状态", "min-width": "80" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type:
                                    scope.row.status === 1
                                      ? "warning"
                                      : "success",
                                  size: "small",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      scope.row.statusName ||
                                        (scope.row.status === 1
                                          ? "正常"
                                          : "预警")
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "warnDesc",
                      label: "预警说明",
                      "min-width": "200",
                      "show-overflow-tooltip": "",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "pagination-box" },
                [
                  _c("el-pagination", {
                    attrs: {
                      background: "",
                      "page-sizes": [10, 20, 40],
                      "page-size": _vm.tableFrom.limit,
                      "current-page": _vm.tableFrom.page,
                      layout: "total, sizes, prev, pager, next",
                      total: _vm.recordTotal,
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handlePageChange,
                    },
                  }),
                ],
                1
              ),
              _c("div", { staticClass: "section-title mt20" }, [
                _vm._v("价格变化趋势"),
              ]),
              _vm.optionData
                ? _c("echarts-new", {
                    attrs: {
                      "option-data": _vm.optionData,
                      styles: _vm.style,
                      height: "100%",
                      width: "100%",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }